<script>
// Components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import UserProfile from "@/router/views/users/user-profile"

// Service
import MarketingDataService from "@/services/MarketingDataService";
import UsersDataService from "@/services/UsersDataService"

// Helper
import UserUtils from '@/helpers/users'
import Storage from '@/helpers/storage'

// External Components
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

import isEmpty from 'is-empty';

const ads = {};
const marketing = {};
const organic = {};
const adsData1 = {};
const adsData2 = {};

export default {
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Moderation Checks",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
    DatePicker,
    VueTabs,
    VTab,
    UserProfile,
    CoolLightBox,
  },

  methods: {
    ...UserUtils,

    _isEmpty(val) {
      return isEmpty(val);
    },

    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      if (this.filters.dates.selected === 'custom' && this.filters.dates.dateRange !== null) {
        this.filters.fromDate = this.$moment(this.filters.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filters.toDate = this.$moment(this.filters.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filters.fromDate === null)
        this.handleDateChange();

      if (this.filters.toDate !== null)
        params['toDate'] = this.filters.toDate;

      if (this.filters.fromDate !== null)
        params['fromDate'] = this.filters.fromDate;

      params['mode'] = this.filters.modes.selected;
      params['sex'] = this.filters.sex.selected;
      params['organic'] = this.filters.organic.selected;
      params['qualityUser'] = this.filters.qualityUser.selected;
      params['priceGroup'] = this.filters.priceGroup.selected;
      params['slGroup'] = this.filters.slGroup.selected;
      params['pmGroup'] = this.filters.pmGroup.selected;
      params['countries'] = this.filters.countries.selected;

      if (!isEmpty(this.filters.adsCosts)) {
        params['adsCosts'] = parseInt(this.filters.adsCosts);
      }

      if (!isEmpty(this.filters.minAge)) {
        params['minAge'] = parseInt(this.filters.minAge);
      }

      if (!isEmpty(this.filters.maxAge)) {
        params['maxAge'] = parseInt(this.filters.maxAge);
      }

      if (this.filters.adsData3.selected !== 'all') {
        params['ads'] = this.filters.adsData3.selected;
      }
      else if (this.filters.adsData2.selected !== 'all') {
        params['ads'] = this.filters.adsData2.selected;
      }
      else if (this.filters.adsData1.selected !== 'all') {
        params['ads'] = this.filters.adsData1.selected;
      }
      else {
        params['ads'] = this.filters.ads.selected;
      }

      return params;
    },

    getGenderSearchImg(search) {
      if (search.length > 1) {
        return require('@/assets/images/man_woman.png')
      }
      else
        return require('@/assets/images/'+(search.includes(1)?'man':'woman')+'.png')
    },

    getRegisterModeImg(mode) {
      return require('@/assets/images/registerMode_' + mode + '.png');
    },

    getRegisterStatusImg(status) {
      return require('@/assets/images/registerStatus_' + status + '.png');
    },

    handleDisplayChange() {
      this.page = 1;

      const params = this.getRequestParams(
          this.page,
          this.pageSizes.selected,
      );

      MarketingDataService.getLeads(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.leads = items;
            this.count = totalItems;
            this.getMediaThumb();
          })
          .catch(error => {
            window.console.error(error);
            //this.$toast.error(this.$t("marketing.leads.errorNoResult"));
          });
    },

    handlePageChange(value) {
      this.page = value;
      this.processFilters();
    },

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filters.dates.selected) {
        case "always":
          this.filters.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filters.fromDate = now.format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filters.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filters.toDate = this.filters.fromDate;
          break;
        case "week":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filters.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filters.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filters.fromDate = null;
          this.filters.toDate = null;
          break;
      }
    },

    getMediaThumb() {
      if (!isEmpty(this.leads)) {
        this.leads.forEach(lead => {
          if (lead.photo && lead.photo.length > 0)
            Storage.getUserMedia(lead.userId, lead.photo, 'lead-user-' + lead.userId);
        });
      }
    },

    getFilters() {
      MarketingDataService.getLeadsFilters()
          .then(response => {
            response.data.filters.modes.forEach(mode => {
              this.filters.modes.options.push(mode);
            });
            response.data.filters.priceGroup.forEach(priceGroup => {
              this.filters.priceGroup.options.push(priceGroup);
            });

            /*response.data.filters.ads.forEach(ad => {
              this.filters.ads.options.push(ad);
            });*/
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("marketing.leads.getFilters"));
          });

      MarketingDataService.getAdsNonOrganicFilters()
          .then(response => {
            marketing.ads = response.data.filters.ads;
            response.data.filters.ads.forEach(ad => {
              this.filters.ads.options.push(ad);
            });
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("marketing.getAdsNonOrganicFilters"));
          });
    },

    processFilters() {
      if (!this.isLoading)
        this.isLoading = true;

      const params = this.getRequestParams(
          this.page,
          this.pageSizes.selected,
      );

      MarketingDataService.getLeads(params)
          .then(response => {
            const { items, totalItems } = response.data;
            this.leads = items;
            this.count = totalItems;
            this.getMediaThumb();
          })
          .catch(error => {
            window.console.error(error);
            //this.$toast.error(this.$t("marketing.leads.errorNoResult"));
          });

      MarketingDataService.getLeadsStats(params)
          .then(response => {
            this.stats.ads.series = response.data.ads.series;
            this.stats.ads.chartOptions = {...this.stats.ads.chartOptions, ...{
                labels: response.data.ads.labels
              }};

            this.stats.modes.series = response.data.modes.series;
            this.stats.modes.chartOptions = {...this.stats.modes.chartOptions, ...{
                labels: response.data.modes.labels
              }};

            this.$refs.leadsStatusPhotoChart.updateSeries([
                {
                  name: "Photo",
                  data: [response.data.total.photo]
                },
                {
                  name: 'Without',
                  data: [response.data.total.exists - response.data.total.photo]
                }
            ]);

            this.$refs.leadsStatusVideoChart.updateSeries([
              {
                name: "Video",
                data: [response.data.total.video]
              },
              {
                name: 'Without',
                data: [response.data.total.exists - response.data.total.video]
              }
            ]);

            this.$refs.leadsStatusPhoneChart.updateSeries([
              {
                name: "Phone",
                data: [response.data.total.phone]
              },
              {
                name: 'Without',
                data: [response.data.total.exists - response.data.total.phone]
              }
            ]);

            this.$refs.leadsStatusQualityChart.updateSeries([
              {
                name: "Quality",
                data: [response.data.total.qualityUsers]
              },
              {
                name: 'Without',
                data: [response.data.total.exists - response.data.total.qualityUsers]
              }
            ]);

            this.$refs.leadsStatusCompleteChart.updateSeries([
              {
                name: "Complete",
                data: [response.data.total.complete]
              },
              {
                name: 'Without',
                data: [response.data.total.exists - response.data.total.complete]
              }
            ]);

            this.$refs.leadsQualityGraph.updateSeries([{
                name: "Quality",
                type: 'bar',
                data: response.data.statusGraph.qualityUsers
              }]);


            this.$refs.leadsDeletedGraph.updateSeries([{
                name: "Exists",
                type: 'bar',
                data: response.data.deletedGraph.exists
              },
              {
                name: "Deleted",
                type: 'bar',
                data: response.data.deletedGraph.deleted
              }]);

            this.$refs.leadsUninstallsGraph.updateSeries([{
                name: "Still Installed",
                type: 'bar',
                data: response.data.uninstallsGraph.exists
              },
              {
                name: "Uninstalls",
                type: 'bar',
                data: response.data.uninstallsGraph.uninstalls
            }]);

            this.$refs.leadsPhotoGraph.updateSeries([{
                name: "Photo",
                type: 'bar',
                data: response.data.statusGraph.photo
              },
              {
                name: "Exists",
                type: 'line',
                data: response.data.statusGraph.users
              }]);

            this.$refs.leadsPhoneGraph.updateSeries([{
              name: "Phone",
              type: 'bar',
              data: response.data.statusGraph.phone
            },
              {
                name: "Exists",
                type: 'line',
                data: response.data.statusGraph.users
              }]);

            this.$refs.leadsVideoGraph.updateSeries([{
              name: "Videos",
              type: 'bar',
              data: response.data.statusGraph.video
            },
              {
                name: "Exists",
                type: 'line',
                data: response.data.statusGraph.users
              }]);

            this.$refs.leadsCompleteGraph.updateSeries([{
              name: "Complete",
              type: 'bar',
              data: response.data.statusGraph.complete
            },
              {
                name: "Exists",
                type: 'line',
                data: response.data.statusGraph.users
              }]);

            this.$refs.leadsTokensPermGraph.updateSeries([
              {
                name: "Leads",
                type: "column",
                data: response.data.tokensPermGraph.leads
              }, {
                name: "Ratio Granted",
                type: "line",
                data: response.data.tokensPermGraph.ratio
              }]);

            this.$refs.leadsTypeGraph.updateSeries([{
              name: "Men",
              type: "column",
              data: response.data.typeGraph.men
            }, {
              name: "Women",
              type: "column",
              data: response.data.typeGraph.women
            }]);

            this.total.exists = response.data.total.exists;
            this.total.tokens_perm = response.data.total.tokens_perm;
            this.total.tokens_perm_perc = response.data.total.tokens_perm_perc;
            this.total.qualityUsers = response.data.total.qualityUsers;
            this.total.leads = response.data.total.leads;
            this.total.men = response.data.total.men;
            this.total.women = response.data.total.women;
            this.total.ageMen = response.data.total.ageMen;
            this.total.ageWomen = response.data.total.ageWomen;
            this.total.cpl = response.data.total.cpl;
            this.total.uninstalls = response.data.total.uninstalls;

            this.isLoading = false;
          })
          .catch(error => {
            window.console.error(error);
            this.isLoading = false;
            //this.$toast.error(this.$t("marketing.leads.errorNoResult"));
          })
    },

    trunc(value) {
      if (!isEmpty(value)) {
        if (value.length > 70)
          return value.substring(0, 70) + "…";
        else
          return value;
      }
      else {
        return "";
      }
    },

    getGenderImg(sex) {
      return require('@/assets/images/'+(sex === 1 ? 'man' : 'woman')+'.png')
    },

    /* User profile */
    openUserPane() {
      if (!this.isUserPaneDisplayed)
        this.isUserPaneDisplayed = true;
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(userId) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = userId; }, 100);
      }
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    }
  },
  watch: {
    "filters.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filters.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
    },
    "filters.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData1.selected = 'all';
      this.filters.adsData2.selected = 'all';
      this.filters.adsData3.selected = 'all';
      this.filters.adsData1.options = [{
        value: 'all', text: 'All Data1'
      }];
      this.filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(ads[newVal])) {
        MarketingDataService.getAdsNonOrganicData1Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData1.options.push(ad);
              });

              ads[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData1Filters"));
            });
      }
      else {
        ads[newVal].forEach(ad => {
          this.filters.adsData1.options.push(ad);
        });
      }
    },
    "filters.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData2.selected = 'all';
      this.filters.adsData3.selected = 'all';
      this.filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData1[newVal])) {
        MarketingDataService.getAdsNonOrganicData2Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData2.options.push(ad);
              });

              adsData1[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData2Filters"));
            });
      }
      else {
        adsData1[newVal].forEach(ad => {
          this.filters.adsData2.options.push(ad);
        });
      }
    },
    "filters.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData3.selected = 'all';
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData2[newVal])) {
        MarketingDataService.getAdsNonOrganicData3Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData3.options.push(ad);
              });

              adsData2[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData3Filters"));
            });
      }
      else {
        adsData2[newVal].forEach(ad => {
          this.filters.adsData3.options.push(ad);
        });
      }
    }
  },

  data() {
    return {
      stats: {
        modes: {
          series:[],
          chartOptions: {
            chart: {
              id: 'leads-modes',
              type: 'donut',
            },
            dataLabels: {
              enabled: true
            },
            labels:[],
            noData: {
              text: 'Loading...'
            },
            legend: {
              position: 'bottom'
            },
          }
        },

        statusComplete: {
          series: [],
          chartOptions: {
            chart: {
              type: 'bar',
              stacked: true,
              stackType: '100%'
            },
            colors: ["#34c38f", "#bbbbbb"],
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            fill: {
              opacity: 1

            },
            stroke: {
              width: 1,
              colors: ['#fff']
            },
            yaxis: [
              {
                show: false
              }
            ],
          }
        },

        statusPhoto: {
          series: [],
          chartOptions: {
            chart: {
              type: 'bar',
              stacked: true,
              stackType: '100%'
            },
            colors: ["#34c38f", "#bbbbbb"],
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            fill: {
              opacity: 1

            },
            stroke: {
              width: 1,
              colors: ['#fff']
            },
            yaxis: [
              {
                show: false
              }
            ],
          },
        },

        statusPhone: {
          series: [],
          chartOptions: {
            chart: {
              type: 'bar',
              stacked: true,
              stackType: '100%'
            },
            colors: ["#34c38f", "#bbbbbb"],
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            fill: {
              opacity: 1

            },
            stroke: {
              width: 1,
              colors: ['#fff']
            },
            yaxis: [
              {
                show: false
              }
            ],
          }
        },

        statusVideo: {
          series: [],
          chartOptions: {
            chart: {
              type: 'bar',
              stacked: true,
              stackType: '100%'
            },
            colors: ["#34c38f", "#bbbbbb"],
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            fill: {
              opacity: 1

            },
            stroke: {
              width: 1,
              colors: ['#fff']
            },
            yaxis: [
              {
                show: false
              }
            ],
          }
        },

        statusQualityUsers: {
          series: [],
          chartOptions: {
            chart: {
              type: 'bar',
              stacked: true,
              stackType: '100%'
            },
            colors: ["#34c38f", "#bbbbbb"],
            plotOptions: {
              bar: {
                horizontal: true,
              },
            },
            fill: {
              opacity: 1

            },
            stroke: {
              width: 1,
              colors: ['#fff']
            },
            yaxis: [
              {
                show: false
              }
            ],
          }
        },

        ads: {
          series:[],
          chartOptions: {
            chart: {
              id: 'leads-ads',
              type: 'donut',
            },
            labels: [],
            dataLabels: {
              enabled: true
            },

            legend: {
              position: 'bottom'
            },
            noData: {
              text: 'Loading...'
            }
          },
        },

        typeGraph: {
          series:[],
          chartOptions: {
            chart: {
              id: 'leads-evol',
              type: 'bar',
              stacked: true,
              height: 350,
              zoom: {
                autoScaleYaxis: true
              },
              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoomin: true,
                  zoomout: true,
                  pan: false,
                  reset: true
                }
              }
            },
            plotOptions: {
              bar: {
                horizontal: false,
                /*dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: '13px',
                    }
                  }
                }*/
              },
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            colors: ['#77B6EA', '#f06292'],
            dataLabels: {
              enabled: false
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 0
                },
                hideOverlappingLabels: true
              }
            },
            noData: {
              text: 'Loading...'
            }
          },
        },

        deletedGraph: {
          series: [],
          chartOptions: {
            chart: {
              type: 'bar',
              stacked: true,
              toolbar: {
                show: true,
              },
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            dataLabels: {
              enabled: false,
            },
            plotOptions: {
              bar: {
                horizontal: false,
                /*dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: '13px',
                    }
                  }
                }*/
              },
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            yaxis: [
              {
                axisTicks: {
                  show: false
                },
                title: {
                  text: "Nb"
                },
              },
            ],
            colors: ["#556ee6", "#ef5744"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          },
        },

        uninstallGraph: {
          series: [],
          chartOptions: {
            chart: {
              type: 'bar',
              stacked: true,
              toolbar: {
                show: true,
              },
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            dataLabels: {
              enabled: false,
            },
            plotOptions: {
              bar: {
                horizontal: false,
                /*dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: '13px',
                    }
                  }
                }*/
              },
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            yaxis: [
              {
                axisTicks: {
                  show: false
                },
                title: {
                  text: "Nb"
                },
              },
            ],
            colors: ["#556ee6", "#ef5744"],
            legend: {
              position: "bottom",
            },
            fill: {
              opacity: 1,
            },
          },
        },

        tokensPermGraph: {
          series: [],
          chartOptions: {
            chart: {
              type: 'line',
              toolbar: {
                show: true,
              },
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            dataLabels: {
              enabled: false,
            },
            plotOptions: {
              bar: {
                horizontal: false,
                /*dataLabels: {
                  total: {
                    enabled: true,
                    style: {
                      fontSize: '13px',
                    }
                  }
                }*/
              },
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            yaxis: [
              {
                axisTicks: {
                  show: false
                },
                title: {
                  text: "Users"
                },
              }, {
                seriesName: 'Ratio Granted',
                opposite: true,
                min: 0,
                max: 100,
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: '#000000'
                },
                labels: {
                  style: {
                    colors: '#000000',
                  }
                },
                title: {
                  text: "Ratio Permission Granted",
                  style: {
                    color: '#000000',
                  }
                },
              },
            ],
            colors: ["#556ee6", "#000000"],
            legend: {
              position: "bottom",
            },
            stroke: {
              curve: "smooth",
              width: 3,
            },
            fill: {
              type:'solid',
              opacity: [0.35, 1],
            },
          },
        },

        photoGraph: {
          series: [],
          chartOptions: {
            chart: {
              type: 'line',
              toolbar: {
                show: true,
              },
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            yaxis: [
              {
                axisTicks: {
                  show: false
                },
                title: {
                  text: "Users"
                },
              },
            ],
          }
        },

        videoGraph: {
          series: [],
          chartOptions: {
            chart: {
              type: 'line',
              toolbar: {
                show: true,
              },
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            yaxis: [
              {
                axisTicks: {
                  show: false
                },
                title: {
                  text: "Users"
                },
              },
            ],
          }
        },

        phoneGraph: {
          series: [],
          chartOptions: {
            chart: {
              type: 'line',
              toolbar: {
                show: true,
              },
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            yaxis: [
              {
                axisTicks: {
                  show: false
                },
                title: {
                  text: "Users"
                },
              },
            ],
          }
        },

        qualityUsersGraph: {
          series: [],
          chartOptions: {
            chart: {
              type: 'bar',
              toolbar: {
                show: true,
              },
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            yaxis: [
              {
                axisTicks: {
                  show: false
                },
                title: {
                  text: "Users"
                },
              },
            ],
          }
        },

        completeGraph: {
          series: [],
          chartOptions: {
            chart: {
              type: 'line',
              toolbar: {
                show: true,
              },
            },
            tooltip: {
              shared: true,
              intersect: false
            },
            dataLabels: {
              enabled: false,
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 11
                },
                hideOverlappingLabels: true
              }
            },
            yaxis: [
              {
                axisTicks: {
                  show: false
                },
                title: {
                  text: "Users"
                },
              },
            ],
          }
        }
      },

      total: {
        leads: 0,
        qualityUsers: 0,
        men: 0,
        women: 0,
        ageMen: 0,
        ageWomen: 0,
        cpl: 0,
        exists: 0,
        tokens_perm: 0,
        uninstalls: 0,
        tokens_perm_perc: 0,
        photo: 0,
        phone: 0,
        video: 0,
        complete: 0,
      },
      leads: [],
      page: 1,
      count: 0,
      isLoading: true,
      title: this.$t("menuitems.marketing.leads"),
      pageSizes: {
        options: ['20', '50', '100'],
        selected: '20'
      },
      pane: {
        installSize: 0
      },
      filters: {
        adsCosts: null,
        fromDate: null,
        toDate: null,
        minAge: null,
        maxAge: null,
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        sex: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Sex'
          }, {
            value: 1, text: 'Male'
          }, {
            value: 2, text: 'Female'
          }]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        qualityUser: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Quality'},
            {value: 1, text: 'Only Quality Users'},
            {value: 0, text: 'No Quality'}
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
        modes: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Modes'
          }]
        },
        priceGroup: {
          selected: 'all',
          options: [
              {value: 'all', text: 'All Price Groups'},
              {value: 'default', text: 'Default Price'}
          ]
        },
        slGroup: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All SLGroups'},
            {value: 'default', text: 'Default'},
            {value: 'group0', text: 'Witness Group'},
            {value: 'group1', text: 'Group 1'},
            {value: 'group2', text: 'Group 2'},
            {value: 'group3', text: 'Group 3'},
            {value: 'group4', text: 'Group 4'}
          ]

        },
        pmGroup: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All PMGroups'},
            {value: 'default', text: 'Default'},
            {value: 'group1', text: 'Group 1'},
            {value: 'group2', text: 'Group 2'},
          ]

        },
        dates: {
          dateRange: null,
          selected: 'today',
          options: [
              {value:'today', text:this.$t("dates.today")},
              {value:'yesterday', text:this.$t("dates.yesterday")},
              {value:'week', text:this.$t("dates.week")},
              {value:'curMonth', text:this.$t("dates.curMonth")},
              {value:'last30Day', text:this.$t("dates.last30Day")},
              {value:'lastMonth', text:this.$t("dates.lastMonth")},
              {value:'last3Month', text:this.$t("dates.last3Month")},
              {value:'curYear', text:this.$t("dates.curYear")},
              {value:'always', text:this.$t("dates.always")},
              {value:'custom', text:this.$t("dates.custom")}
          ]
        }
      },
      /* User profile */
      isUserPaneDisplayed: false,
      userTabs:[],
      userTabsActive: '',
      userMedia: {
        media: [],
        index: -1
      },
    };
  },

  mounted() {
    this.getFilters();
    this.processFilters();
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">
      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- Filters -->
      <div class="card">
        <div class="card-body row">
          <b-form inline class="row gy-2 gx-3 align-items-center" id="leadsFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="leadsDatesFilter"
                  @change="handleDateChange"
                  v-model="filters.dates.selected"
                  class="form-select me-lg-1"
                  :options="filters.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filters.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filters.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="leadsCountriesFilter"
                  v-model="filters.countries.selected"
                  class="form-select me-lg-1"
                  :options="filters.countries.options">
              </b-form-select>
            </div>

            <!-- Organic -->
            <div class="col-sm-auto">
              <b-form-select
                  id="leadsOrganicFilter"
                  v-model="filters.organic.selected"
                  class="form-select me-lg-1"
                  :options="filters.organic.options">
              </b-form-select>
            </div>

            <!-- Ads -->
            <div class="col-sm-auto">
              <b-form-select
                  id="leadsAdsFilter"
                  v-model="filters.ads.selected"
                  class="form-select me-lg-1"
                  :options="filters.ads.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.ads.selected !== 'all'">
              <b-form-select
                  id="leadsAdsData1Filter"
                  v-model="filters.adsData1.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData1.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.adsData1.selected !== 'all'">
              <b-form-select
                  id="leadsAdsData2Filter"
                  v-model="filters.adsData2.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData2.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.adsData2.selected !== 'all'">
              <b-form-select
                  id="leadsAdsData3Filter"
                  v-model="filters.adsData3.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData3.options">
              </b-form-select>
            </div>

            <!-- Modes -->
            <div class="col-sm-auto">
              <b-form-select
                  id="leadsModesFilter"
                  v-model="filters.modes.selected"
                  class="form-select me-lg-1"
                  :options="filters.modes.options">
              </b-form-select>
            </div>

            <!-- Sex -->
            <div class="col-sm-auto">
              <b-form-select
                  id="leadsDevicesFilter"
                  v-model="filters.sex.selected"
                  class="form-select me-lg-1"
                  :options="filters.sex.options">
              </b-form-select>
            </div>

            <!-- QualityUsers -->
            <div class="col-sm-auto">
              <b-form-select
                  id="leadsQualityFilter"
                  v-model="filters.qualityUser.selected"
                  class="form-select me-lg-1"
                  :options="filters.qualityUser.options">
              </b-form-select>
            </div>

            <!-- SLGroups -->
            <div class="col-sm-auto">
              <b-form-select
                  id="leadsSLGroupFilter"
                  v-model="filters.slGroup.selected"
                  class="form-select me-lg-1"
                  :options="filters.slGroup.options">
              </b-form-select>
            </div>

            <!-- PMGroups -->
            <div class="col-sm-auto">
              <b-form-select
                  id="leadsPMGroupFilter"
                  v-model="filters.pmGroup.selected"
                  class="form-select me-lg-1"
                  :options="filters.pmGroup.options">
              </b-form-select>
            </div>

            <!-- Price Groups -->
            <div class="col-sm-auto">
              <b-form-select
                  id="leadsPriceGroupFilter"
                  v-model="filters.priceGroup.selected"
                  class="form-select me-lg-1"
                  :options="filters.priceGroup.options">
              </b-form-select>
            </div>

            <!-- Ads Costs -->
            <div class="col-sm-auto">
              <b-form-input
                v-model="filters.adsCosts"
                placeholder="Ads Costs (€)"
                class="me-lg-1"
              >
              </b-form-input>
            </div>

            <!-- Ages -->
            <div class="col-sm-auto">
              <b-form-input
                  v-model="filters.minAge"
                  placeholder="Age min"
                  style="width:80px;"
              >
              </b-form-input>
            </div>
            <div class="col-sm-auto">
              <b-form-input
                  v-model="filters.maxAge"
                  placeholder="Age max"
                  class="me-lg-1"
                  style="width:90px;"
              >
              </b-form-input>
            </div>



            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
        </div>
      </div>

      <!-- Loader -->
      <div class="row d-flex justify-content-center">
        <vue-ellipse-progress
            v-show="isLoading"
            :loading="isLoading"
            :angle="-90"
            color="#50a5f1"
            emptyColor="#999"
            emptyColorFill="#f8f8fb"
            :size="100"
            :thickness="3"
            :emptyThickness="2"
            lineMode="out 2"
            animation="bounce 700 400"
            fontColor="#666"
            :half="false"
            class="mt-5 mb-5"
            fontSize="1rem">
        </vue-ellipse-progress>
      </div>

      <!-- Stats Plain -->
      <div class="row">
        <!-- Leads -->
        <div class="col-lg-2">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Leads</p>
                  <h5 class="mb-0">{{ total.leads }} <span v-if="total.cpl > 0" class="text-success font-size-12">{{ total.cpl }}€ /lead</span></h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-success rounded-circle white font-size-20"
                  >
                    <i class="bx bx-download"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Men -->
        <div class="col-lg-2">
          <div class="card blog-stats-wid ">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Men</p>
                  <h5 class="mb-0">{{ total.men }} <span class="text-muted"><small>{{ total.ageMen }} y.o</small></span></h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-info text-white rounded-circle font-size-20"
                  >
                    <i class="fas fa-male"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Women -->
        <div class="col-lg-2">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Women</p>
                  <h5 class="mb-0">{{ total.women }} <span class="text-muted"><small>{{ total.ageWomen }} y.o</small></span></h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-pink rounded-circle text-white font-size-20"
                  >
                    <i class="fas fa-female"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Tokens -->
        <div class="col-lg-2">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Permissions Notifications</p>
                  <h5 class="mb-0">{{ total.tokens_perm }} - {{ total.tokens_perm_perc }}%</h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-info rounded-circle text-white font-size-20"
                  >
                    <i class="bx bx-alarm"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Exists -->
        <div class="col-lg-1">
          <div class="card bg-info blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="">
                  <p class="text-white mb-2">Still Exists</p>
                  <h5 class="mb-0 text-white"><b>{{ total.exists }}</b></h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Uninstalls -->
        <div class="col-lg-1">
          <div class="card bg-danger blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="">
                  <p class="text-white mb-2">Uninstalls</p>
                  <h5 class="mb-0 text-white"><b>{{ total.uninstalls }}</b></h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Quality -->
        <div class="col-lg-2">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Quality Users</p>
                  <h5 class="mb-0">{{ total.qualityUsers }}</h5>
                </div>
                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-info rounded-circle text-white font-size-20"
                  >
                    <i class="bx bx-like"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Charts -->
      <div class="row">
        <div class="col-12 col-lg-3">

          <div class="card">
            <div class="card-body" id="cardChartMode">
              <h5 class="card-title">Modes</h5>
              <apexchart
                  ref="leadsModesChart"
                  type="donut"
                  height="350"
                  dir="ltr"
                  :series="stats.modes.series"
                  :options="stats.modes.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-3">

          <div class="card">
            <div class="card-body" id="cardChartAds">
              <h5 class="card-title">Ads</h5>
              <apexchart
                  ref="leadsAdsChart"
                  type="donut"
                  height="350"
                  dir="ltr"
                  :series="stats.ads.series"
                  :options="stats.ads.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-3">
          <div class="card">
            <div class="card-body">
              <h5 class="mb-0">Photos</h5>
              <apexchart
                  ref="leadsStatusPhotoChart"
                  type="bar"
                  height="130"
                  dir="ltr"
                  :series="stats.statusPhoto.series"
                  :options="stats.statusPhoto.chartOptions"
              ></apexchart>

              <h5 class="mb-0">Quality Users</h5>
              <apexchart
                  ref="leadsStatusQualityChart"
                  type="bar"
                  height="130"
                  dir="ltr"
                  :series="stats.statusQualityUsers.series"
                  :options="stats.statusQualityUsers.chartOptions"
              ></apexchart>

              <h5 class="mb-0">Videos</h5>
              <apexchart
                  ref="leadsStatusVideoChart"
                  type="bar"
                  height="130"
                  dir="ltr"
                  :series="stats.statusVideo.series"
                  :options="stats.statusVideo.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-3">
          <div class="card">
            <div class="card-body">
              <h5 class="mb-0">Phone</h5>
              <apexchart
                  ref="leadsStatusPhoneChart"
                  type="bar"
                  height="130"
                  dir="ltr"
                  :series="stats.statusPhone.series"
                  :options="stats.statusPhone.chartOptions"
              ></apexchart>

              <h5 class="mb-0">Complete</h5>
              <apexchart
                  ref="leadsStatusCompleteChart"
                  type="bar"
                  height="130"
                  dir="ltr"
                  :series="stats.statusComplete.series"
                  :options="stats.statusComplete.chartOptions"
              ></apexchart>

            </div>
          </div>
        </div>

      </div>

      <!-- Charts 2 -->
      <div class="row">
        <div class="col-12">

          <div class="card">
            <div class="card-body" id="cardChartTypes">
              <h5 class="card-title">Leads History</h5>
              <apexchart
                  ref="leadsTypeGraph"
                  type="line"
                  dir="ltr"
                  height="350"
                  :series="stats.typeGraph.series"
                  :options="stats.typeGraph.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>

      <div class="row">

        <div class="col-12 col-lg-6">

          <div class="card">
            <div class="card-body" id="cardChartTypes">
              <h5 class="card-title">Uninstalls History</h5>
              <apexchart
                  ref="leadsUninstallsGraph"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="stats.uninstallGraph.series"
                  :options="stats.uninstallGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

          <div class="card">
            <div class="card-body" id="cardChartDeleted">
              <h5 class="card-title">Users Deleted History</h5>
              <apexchart
                  ref="leadsDeletedGraph"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="stats.deletedGraph.series"
                  :options="stats.deletedGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-6">
          <div class="card">
            <div class="card-body" id="cardChartQuality">
              <h5 class="card-title">Users Quality History</h5>
              <apexchart
                  ref="leadsQualityGraph"
                  type="bar"
                  dir="ltr"
                  height="350"
                  :series="stats.qualityUsersGraph.series"
                  :options="stats.qualityUsersGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

          <div class="card">
            <div class="card-body" id="cardChartTokens">
              <h5 class="card-title">Users with Notifications Granted</h5>
              <apexchart
                  ref="leadsTokensPermGraph"
                  type="line"
                  dir="ltr"
                  height="350"
                  :series="stats.tokensPermGraph.series"
                  :options="stats.tokensPermGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Charts Status 1 -->
      <div class="row">

        <div class="col-12 col-lg-6">

          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Photo History</h5>
              <apexchart
                  ref="leadsPhotoGraph"
                  type="line"
                  dir="ltr"
                  height="350"
                  :series="stats.photoGraph.series"
                  :options="stats.photoGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-6">

          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Video History</h5>
              <apexchart
                  ref="leadsVideoGraph"
                  type="line"
                  dir="ltr"
                  height="350"
                  :series="stats.videoGraph.series"
                  :options="stats.videoGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Charts Status 2 -->
      <div class="row">

        <div class="col-12 col-lg-6">

          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Phone History</h5>
              <apexchart
                  ref="leadsPhoneGraph"
                  type="line"
                  dir="ltr"
                  height="350"
                  :series="stats.phoneGraph.series"
                  :options="stats.phoneGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-6">

          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Complete Members History</h5>
              <apexchart
                  ref="leadsCompleteGraph"
                  type="line"
                  dir="ltr"
                  height="350"
                  :series="stats.completeGraph.series"
                  :options="stats.completeGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Top list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="leads-list"
            ></b-pagination>
            </div>
        </div>
      </div>

      <div class="row bg-white" v-if="!isLoading && leads.length > 0">
        <!-- Result list -->
        <div class="table-responsive">
          <table
              id="leads-list"
              class="table project-list-table table-nowrap table-centered table-borderless align-middle">
            <thead>
            <tr>
              <th scope="col">{{ $t("marketing.createdAt") }}</th>
              <th scope="col">{{ $t("marketing.status") }}</th>
              <th scope="col">{{ $t("marketing.campaign") }}</th>
              <th scope="col">Quality ?</th>
              <th scope="col">{{ $t("marketing.country") }}</th>
              <th scope="col">{{ $t("marketing.user") }}</th>
              <th scope="col">{{ $t("marketing.search") }}</th>
              <th scope="col">{{ $t("marketing.registerMode") }}</th>
              <th scope="col">{{ $t("marketing.ids") }}</th>
              <th scope="col">{{ $t("marketing.language") }}</th>
              <th scope="col">Groups</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="lead in leads" :key="lead.leadId">
              <td>
                <i class="bx bx-calendar-event"></i> {{ new Date(lead.createdAt) | moment('DD MMM YYYY HH:mm') }}
                <br><b>{{ lead.appVersionName }}</b> ({{ lead.appVersionCode }})
              </td>
              <td>
                <img width="32" height="32" :src="getRegisterStatusImg(lead.registerStatus)" :alt="lead.registerStatus" :title="lead.registerStatus" />
              </td>
              <td>
                <b class="text-success">{{ lead.organic === 1 ? "Organic" : "Marketing"}}</b><br>
                <b class="text-primary">{{ lead.adSource }}</b><br>
                <b>{{ lead.adCampaign || "-"}}</b><span v-show="!_isEmpty(lead.adChannel)"><i> ({{ lead.adChannel }})</i></span>
                <span class="text-muted" v-show="!_isEmpty(lead.adData1)"><br>{{ trunc(lead.adData1) }}</span>
                <span class="text-muted" v-show="!_isEmpty(lead.adData2)"><br>{{ trunc(lead.adData2) }}</span>
                <span class="text-muted" v-show="!_isEmpty(lead.adData3)"><br>{{ trunc(lead.adData3) }}</span>
              </td>
              <td>
                <span
                    class="badge"
                    :class="{
                      'bg-success text-light': lead.isQualityUser === 1,
                      'bg-light text-dark': lead.isQualityUser === 0
                    }"
                >{{ $t(`marketing.quality_user_${lead.isQualityUser}`) }}</span>
              </td>
              <td>
                <country-flag
                    :country="lead.country"
                    size="normal"
                  />
              </td>
              <td>
                <div class="media cursor-pointer" @click="showUser(lead.userId)">
                  <div class="avatar-xs">
                    <img
                        :id="`lead-user-${lead.userId}`"
                        :src="require('@/assets/images/users/default-user.png')"
                        class="d-flex rounded-circle avatar-xs" />
                  </div>
                  <div class="media-body ms-1">
                    <div>
                      <h5 class="font-size-12 mb-0">
                        <span
                            :class="{
                            'text-primary': lead.sex === 1,
                            'text-danger': lead.sex === 2,
                            'text-dark': lead.sex === 0,
                          }"
                        >
                          {{ lead.name || $t("deleted") }}
                        </span> {{ lead.age }}</h5>
                      <small class="text-muted">{{ lead.userId }}</small><br>
                      <small class="text-muted text-truncate">{{ lead.locality }}</small>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <img :src="getGenderSearchImg(lead.search)" alt="">
              </td>
              <td>
                <img width="32" height="32" :src="getRegisterModeImg(lead.registerMode)" :alt="lead.registerMode" :title="lead.registerMode" />
              </td>
              <td>
                <i class="fas fa-mail-bulk"></i> <small>{{ lead.email}}</small><br>
                <i class="fas fa-phone"></i> <small>{{ lead.phone}}</small><br>
                <i class="fas fa-network-wired"></i> <small>{{ lead.ip || 'no ip'}}</small>
              </td>
              <td><h5>{{ lead.language }}</h5></td>
              <td>
                <small>SLG: {{ lead.slGroup }}</small>
                <br><small>PMG: {{ lead.pmGroup }}</small>
                <br><small>Price: {{ lead.priceGroup }}</small>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- END Result list -->
      </div>

      <!-- Result Empty -->
      <div class="row" v-if="!isLoading && leads.length === 0">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Empty Result</h4>
              <p>No leads were found for these filters. Try again.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- bottom list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="leads-list"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <b-sidebar id="sidebar-right" right v-model="isUserPaneDisplayed">
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia">
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>

  </Layout>
</template>

<style>

  .gender-img {
    max-width: 30px;
    margin-right: 10px;
  }

  .cursor-pointer {
    cursor:pointer;
  }

  .b-sidebar-right {
    width:35%;
  }

  .b-sidebar-body {
    padding:16px;
  }

</style>
